import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import PropTypes from 'prop-types';
import BrickOverlay from './brick-overlay';
import FrameEventService from '../../shared/services/frame-event-service';

class BrickPoster extends React.Component {

  static propTypes = {
    /*eslint-disable */
    brickData: PropTypes.object.isRequired,
    /*eslint-enable */
    onRate: PropTypes.func.isRequired,
    onQueue: PropTypes.func.isRequired,
    onListMenuOpen: PropTypes.func.isRequired,
    onErasedRating: PropTypes.func.isRequired,
    onCTAClick: PropTypes.func.isRequired,
  };

  state = {
    showOverlay: this.props.brickData.isModalBrick,
    hoverDisabled: false,
  };

  handleOverlayShown = () => {
    this.setState({ showOverlay: true });
  };

  handleOverlayHidden = () => {
    if (!this.state.hoverDisabled || !this.props.brickData.isModalBrick) {
      this.setState({ showOverlay: false });
    }
  };

  handleMobileModal = () => {
    const brickData = this.props.brickData;

    if (!brickData.isModalBrick) {
      FrameEventService.sendBrickClicked(brickData);
    }
  };

  disableHover = () => {
    this.setState({ hoverDisabled: true, showOverlay: true });
  };

  enableHover = () => {
    this.setState({ hoverDisabled: false, showOverlay: true });
  };

  renderOverlay = () => (
    <BrickOverlay
      brickData={this.props.brickData}
      showOverlay={this.state.showOverlay}
      onRate={this.props.onRate}
      onQueue={this.props.onQueue}
      disableHover={this.disableHover}
      enableHover={this.enableHover}
      onListMenuOpen={this.props.onListMenuOpen}
      onErasedRating={this.props.onErasedRating}
      onCTAClick={this.props.onCTAClick}
    />
  );

  render() {
    return (
      /* eslint-disable jsx-a11y/no-static-element-interactions */
      <div
        className="brick-top"
        onMouseOver={this.handleOverlayShown}
        onMouseLeave={this.handleOverlayHidden}

        onClick={this.handleMobileModal}
      >
        {/*
           WARNING: Do not change the cut-off-frame class name or be aware that the
                    height is being overwritten in the super widget project.
         */}
        <div className="cut-off-frame">
          <img
            src={this.props.brickData.posterUrl}
            alt={this.props.brickData.title}
          />
        </div>

        <ReactCSSTransitionGroup transitionName="fade" transitionEnterTimeout={150} transitionLeaveTimeout={150}>
          { this.state.showOverlay ? this.renderOverlay() : null }
        </ReactCSSTransitionGroup>

      </div>
      /* eslint-enable jsx-a11y/no-static-element-interactions */
    );
  }
}

export default BrickPoster;



// WEBPACK FOOTER //
// ./src/client/components/brick-poster.jsx